






































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Route } from "vue-router";
import Draggable, { ChangeEvent } from "vuedraggable";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import { IResource } from "../../types/resource";
import RouteName from "../../router/name";
import ResourceMixin from "../../mixins/resource";
import { IGroup, usernameWithDomain } from "../../types/actor";
import ResourceDropdown from "./ResourceDropdown.vue";
import { UPDATE_RESOURCE } from "../../graphql/resources";

@Component({
  components: { Draggable, ResourceDropdown },
})
export default class FolderItem extends Mixins(ResourceMixin) {
  @Prop({ required: true, type: Object }) resource!: IResource;

  @Prop({ required: true, type: Object }) group!: IGroup;

  @Prop({ required: false, default: false }) inline!: boolean;

  list = [];

  groupObject: Record<string, unknown> = {
    name: `folder-${this.resource?.title}`,
    pull: false,
    put: ["resources"],
  };

  RouteName = RouteName;

  ResourceMixin = ResourceMixin;

  usernameWithDomain = usernameWithDomain;

  async onChange(evt: ChangeEvent<IResource>): Promise<Route | undefined> {
    if (evt.added && evt.added.element) {
      const movedResource = evt.added.element as IResource;
      const updatedResource = await this.moveResource(movedResource);
      if (updatedResource && this.resource.path) {
        // eslint-disable-next-line
        // @ts-ignore
        return this.$router.push({
          name: RouteName.RESOURCE_FOLDER,
          params: {
            // eslint-disable-next-line
            // @ts-ignore
            path: ResourceMixin.resourcePathArray(this.resource),
            preferredUsername: this.group.preferredUsername,
          },
        });
      }
    }
    return undefined;
  }

  async moveResource(resource: IResource): Promise<IResource | undefined> {
    try {
      const { data } = await this.$apollo.mutate<{ updateResource: IResource }>(
        {
          mutation: UPDATE_RESOURCE,
          variables: {
            id: resource.id,
            path: `${this.resource.path}/${resource.title}`,
            parentId: this.resource.id,
          },
        }
      );
      if (!data) {
        console.error("Error while updating resource");
        return undefined;
      }
      return data.updateResource;
    } catch (e: any) {
      Snackbar.open({
        message: e.message,
        type: "is-danger",
        position: "is-bottom",
      });
      return undefined;
    }
  }
}
